import type { TypedActionWithPayload } from '@/types/redux';

/* Action Types */
export const LOAD_LIVE_CATALOG_REGISTRATION_FAIL = 'la/domain/liveCatalogRegistration/LOAD_FAIL';
export const LOAD_LIVE_CATALOG_REGISTRATION_REQUEST = 'la/domain/liveCatalogRegistration/LOAD_REQUEST';

export const LOAD_LIVE_CATALOG_REGISTRATION_SUCCESS = 'la/domain/liveCatalogRegistration/LOAD_SUCCESS';
export type LOAD_LIVE_CATALOG_REGISTRATION_SUCCESS_ACTION = TypedActionWithPayload<
    typeof LOAD_LIVE_CATALOG_REGISTRATION_SUCCESS,
    {
        approved: boolean;
        bidLimit: number;
        catalogId: number;
        created: number;
        publishKey: string;
        wasApproved: boolean;
    },
    {
        actionTime: number;
        catalogId: number;
    }
>;

export const LOAD_UPCOMING_CATALOG_REGISTRATION_FAIL = 'la/domain/upcomingCatalogRegistration/LOAD_FAIL';
export const LOAD_UPCOMING_CATALOG_REGISTRATION_REQUEST = 'la/domain/upcomingCatalogRegistration/LOAD_REQUEST';
export const LOAD_UPCOMING_CATALOG_REGISTRATION_SUCCESS = 'la/domain/upcomingCatalogRegistration/LOAD_SUCCESS';
